import DynamicTable from '../../../components/tables/dynamicTable';
import { getDynamicSelectData } from '../../../utils/api/data';
import Sidebar from '../../../components/sidebar/Sidebar';
import NavBar from '../../../components/navbar/NavBar';
import React, {useState, useEffect } from 'react';
import { config } from "../../../config/Constants";
import Axios from 'axios';
import Cookies from 'js-cookie';
import './costtrends.css';
import { keyframes } from '@emotion/react';

const CostTrends = () => {
  const [reportData, setReportData] = useState([]);

  const getReportData = async(value) => {
    if (Cookies.get('cp-cn') !== 'GTMS-CP') {
      const response = await getDynamicSelectData({
        selectValues: '* EXCLUDE(CUSTOMER)', 
        tableName: 'CUSTOMER_PORTAL.REPORT.COST_TRENDS',
        whereField: ["CUSTOMER"], 
        whereOperators:["="], 
        whereValue: [Cookies.get('cp-cn')], 
        orderBy: "CATEGORY_ORDER ASC",
        db: 'SF'
      });
      setReportData({data: response})
    }
    if (Cookies.get('cp-cn') === 'GTMS-CP') {
      const response = await Axios.get(config.url.GET_REPORT, {
      params: {
        reportName: "costtrendsreport",
        companyName: Cookies.get("cp-cn"),
      },
    });
      setReportData({data: response.data.report})
    };
  }

  // Set initial data inside table
  useEffect(() => { getReportData(); }, []);

  return (
    <div className='costTrendsPage'>
      <div className="LandingPageContainer">
        <NavBar />
        <Sidebar />
        <div className="costTrendsPageContent">
          <div className="costTrendsTop">
            <div className="costTrendsTitle">
              <h1>Cost Trend</h1>
            </div>
          </div>
          <div className="costTrendMid">
            <div className="ctReportSpace">
              <div className="report">
                <DynamicTable dataObject={reportData}/> 
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default CostTrends